import { Box, Button, Typography } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { DataTable } from "./ui/DataTable";
import AppRights from "../services/AppRights";
import { _ROLES_BACK } from "../utils/constants";

export const ListingPage = ({
  icon = null,
  title,
  roles = [_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL],
  filterComponents = null,
  isDataLoading = false,
  data = [],
  columns = [],
  defaultColDef = {},
  agGridProps = {},
  addButton = {
    title: "Add",
    onClick: () => {},
  },
}) => {
  return (
    <>
      <AppRights roles={roles} />
      <Box
        width={"100%"}
        p={2}
        sx={{
          backgroundColor: "white",
        }}
      >
        <Box
          width={"100%"}
          display={"flex"}
          gap={1}
          alignItems={"center"}
          sx={{
            borderBottom: "1px solid #ccc",
          }}
        >
          {icon}
          <Typography variant="h6" component="div">
            {title}
          </Typography>
        </Box>
        <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 2,
            }}
          >
            {filterComponents}
          </Box>
          <Box>
            <Button
              variant="contained"
              size="small"
              title={addButton.title}
              startIcon={<AddCircleIcon />}
              color="success"
              onClick={addButton.onClick}
            >
              {addButton.title}
            </Button>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          mt: 1,
          width: "100%",
        }}
      >
        <DataTable
          rowHeight={40}
          isDataLoading={isDataLoading}
          rows={data}
          columns={columns}
          showExport={false}
          showFullScreen={false}
          agGridProps={{
            cellSelection: false,
            suppressCellFocus: true,
            defaultColDef: defaultColDef,
            ...agGridProps,
          }}
        />
      </Box>
    </>
  );
};
